import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import router from "./router/index.js";
import axios from './http'
import 'amfe-flexible'
Vue.config.productionTip = false
Vue.prototype.$axios = axios;
Vue.use(Antd);
Vue.use(ElementUI);
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
